export default "__VITE_ASSET__cq9Hj7EA__"